interface FinalCTAProps {
  onCTAClick: () => void;
}

export default function FinalCTA({ onCTAClick }: FinalCTAProps) {
  return (
    <section className="py-16 sm:py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #f97316 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl p-8 sm:p-12 md:p-16 text-center shadow-2xl border border-gray-700">
          {/* Icon */}
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mx-auto mb-6 sm:mb-8 shadow-lg">
            <i className="ri-rocket-2-line text-3xl sm:text-4xl text-white"></i>
          </div>

          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 sm:mb-6 leading-tight break-words">
            Passez à la vitesse supérieure
          </h2>
          <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-10 leading-relaxed max-w-3xl mx-auto break-words">
            Obtenez des rendez-vous qualifiés maintenant et transformez votre présence digitale en véritable machine à générer des leads
          </p>

          {/* CTA Button */}
          <button
            data-iclosed-link="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
            data-embed-type="popup"
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-block mb-6 sm:mb-8"
          >
            Obtenir des rendez-vous qualifiés
          </button>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 pt-6 sm:pt-8 border-t border-white/10">
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-shield-check-line text-xl sm:text-2xl text-emerald-400 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Garantie 30 jours</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-time-line text-xl sm:text-2xl text-teal-400 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Résultats en 90 jours</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-customer-service-line text-xl sm:text-2xl text-orange-400 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Support illimité</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <i className="ri-star-fill text-xl sm:text-2xl text-yellow-400 flex-shrink-0"></i>
              <span className="text-xs sm:text-sm font-medium whitespace-nowrap">4.9/5 satisfaction</span>
            </div>
          </div>
        </div>

        {/* Additional Benefits */}
        <div className="grid md:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
          <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-5 sm:p-6 text-center border border-orange-200">
            <i className="ri-calendar-check-line text-2xl sm:text-3xl text-orange-600 mb-3"></i>
            <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base break-words">Démarrage rapide</h4>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Premiers leads en moins de 4 semaines
            </p>
          </div>
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-5 sm:p-6 text-center border border-teal-200">
            <i className="ri-team-line text-2xl sm:text-3xl text-teal-600 mb-3"></i>
            <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base break-words">Équipe dédiée</h4>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Un chef de projet à votre écoute
            </p>
          </div>
          <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-5 sm:p-6 text-center border border-emerald-200">
            <i className="ri-line-chart-line text-2xl sm:text-3xl text-emerald-600 mb-3"></i>
            <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base break-words">ROI augmenté</h4>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Investissement rentabilisé rapidement
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
